import React, { useState } from 'react';
import './VirtualCFO.css';

function VirtualCFO() {
  const [activeIndex, setActiveIndex] = useState(null);

  const offerings = [
    {
      title: 'Financial Planning & Strategy',
      content: [
        'Designing short- and long-term financial plans',
        'Aligning business goals with financial KPIs',
        'Scenario analysis and business forecasting',
        'Growth strategy consultation based on financial modeling'
      ]
    },
    {
      title: 'Budgeting & Cash Flow Management',
      content: [
        'Creating realistic budgets and cost-control frameworks',
        'Monitoring and optimizing cash flow operations',
        'Variance analysis and expenditure tracking',
        'Guidance on working capital efficiency'
      ]
    },
    {
      title: 'Investor & Board Reporting',
      content: [
        'Preparing and presenting investor-ready reports',
        'Timely updates for board and stakeholders',
        'KPI dashboards and performance insights',
        'Compliance and audit preparedness reports'
      ]
    },
    {
      title: 'Fundraising Support',
      content: [
        'Building investor pitch decks and financial models',
        'Valuation guidance and due diligence assistance',
        'Support for equity and debt fundraising rounds',
        'Interfacing with banks, VCs, and angel networks'
      ]
    },
    {
      title: 'Systems & Process Implementation',
      content: [
        'Implementing cloud-based accounting systems',
        'Automating reporting and internal controls',
        'Custom financial workflows for scaling startups',
        'ERP, MIS, and compliance tool integration'
      ]
    }
  ];

  const toggleAccordion = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  return (
    <div className="service-page">
      {/* Hero Section */}
      <section
        className="hero-image-section"
        style={{ backgroundImage: "url('/images/virtual_cfo_hero.png')" }}
      >
        <div className="hero-text-container">
          <h1>Virtual CFO Services</h1>
          <p>Strategic financial leadership to scale your business efficiently</p>
        </div>
      </section>

      {/* Content Section */}
      <section className="service-content">
        <div className="content-left">
          <h2>Partner with a Virtual CFO</h2>
          <p>FINTEXL Virtual CFO services provide expert financial oversight, strategy, and systems implementation without the cost of a full-time CFO.</p>
          <p>Whether you're a startup or scaling enterprise, our Virtual CFOs help manage growth, optimize budgets, and align your business plans with realistic financial goals.</p>
          <p>We oversee financial forecasting, fundraising, investor reporting, and ensure that your business remains audit-ready and financially strong.</p>
          <p>Virtual CFOs are ideal for dynamic organizations needing high-level support but with a lean and agile model.</p>
        </div>
      </section>

      {/* Offerings Accordion */}
      <section className="accordion-section">
        <h2>Our Offerings</h2>
        <div className="accordion-container">
          {offerings.map((item, index) => (
            <div key={index} className={`accordion-item ${activeIndex === index ? 'active' : ''}`}>
              <div className="accordion-header" onClick={() => toggleAccordion(index)}>
                <span className="icon">{activeIndex === index ? '−' : '+'}</span>
                <div className="accordion-title">{item.title}</div>
              </div>
              <div className="accordion-body" style={{ display: activeIndex === index ? 'block' : 'none' }}>
                <ul>
                  {item.content.map((point, idx) => (
                    <li key={idx}>{point}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

export default VirtualCFO;


